<template>
  <a-button class="button-speech" type="text" :loading="loading" @click="toggleAnchor">

    <PushpinOutlined class="icon" />

    {{anchored ? 'Desanclar ticket' : 'Anclar ticket' }}
  </a-button>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { PushpinOutlined } from "@ant-design/icons-vue";
import { message } from 'ant-design-vue';

import type { Ticket } from "@/@types/global";
import { ticketService } from "@/app/workspace/services/TicketService";
import { ResponseError } from '@/app/shared/utils/httpManager';
import { useStore } from "vuex";
import EventBus from "@/app/shared/utils/eventBus";
import { WorkspaceEvent } from "@/app/workspace/domain/events";
import { ModeFetchWorkspace } from "../../utils/enums";

const props = defineProps<{ ticket: Ticket }>();

const store = useStore();

const emit = defineEmits<{
  (event: "update:ticket"): void;
}>();

const loading = ref(false);
const ticketId = Number(props.ticket.id);
const anchored = ref<boolean>(!!props.ticket?.anchored);

watch(
  () => props.ticket?.anchored,
  (v) => { anchored.value = !!v },
  { immediate: true}
);

const toggleAnchor = async () => {
  const nextAnchored = !anchored.value;
  try {
    loading.value = true;
    await ticketService.updateTicket(ticketId, {anchored: nextAnchored});
    emit("update:ticket");

    // Solo si ANCLAS → refrescas pagina del ticket y pagina 1
    if (nextAnchored) {
      await store.dispatch("fetchActiveWorkspaceTickets", {
        mode: ModeFetchWorkspace.RefreshByTicket,
        ticketId: props.ticket.id,
      });
    } else {
      // Si DESANCLAS → solo mover en el store
      await store.dispatch("moveTicketAfterUnanchor", {
        ticket: props.ticket,
      });
    }

    message.success(nextAnchored ? "Ticket anclado con éxito." : "Ticket desanclado con éxito.");
    // EventBus.emit(WorkspaceEvent.RESET_LIST);
  } catch (error) {
    console.error(error);
    const messageError =
      error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

    message.error(messageError);
  } finally {
    loading.value = false;
  }
}

</script>

<style lang="sass" scoped>
.button-speech
  display: flex
  align-items: center
  justify-content: flex-start
  width: 100%

.icon
  font-size: 18px
</style>
